export const buildInventoryPatch = (field: string, value: string | number | null) =>
    JSON.stringify({ [field]: value });
